<template>
  <div>
    <b-toast
      id="toast-check-modal-report-class-teacher"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-modal-report-class-teacher"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <div class="loading-full" v-show="headerData == null" />
    <div class="report-class-content">
      <b-breadcrumb>
        <b-breadcrumb-item
          :to="
            $route.params.flagReport
              ? '/student/evaluations-reports'
              : '/student/class'
          "
          >{{ $t("class-student.sub-titulo-tab") }}</b-breadcrumb-item
        >
        <b-breadcrumb-item active>{{
          $t("class-student.sub-titulo-tab-report").concat(": ",headerData != null ?headerData.date:"")
        }}</b-breadcrumb-item>
      </b-breadcrumb>
        <div class="card" v-if="headerData != null">
          <div class="card-body py-4">
            <router-link
              class="back-step mt-0"
              :to="
                $route.params.flagReport
                  ? '/student/evaluations-reports'
                  : '/student/class'
              "
            >
              <p>
                <icon name="arrow-left" />{{
                  $t("planesYPrecios.regresar")
                }}
              </p>
            </router-link>
            <h6
              class="sub-title mb-0"
              v-if="headerData != null && headerData.groupDetail != null"
            >
              <span class="d-flex justify-content-center align-items-center">
                {{
                  headerData.groupDetail.flagGroup
                    ?  $t("class-student.group").concat(" ",headerData.groupDetail.code) 
                    : headerData.groupDetail.strStudents
                }}
                <icon
                  v-if="headerData.groupDetail.flagGroup == true"
                  name="alert"
                  class="ml-2"
                  id="btnTooltipStudentGroup"
                  style="cursor: pointer"
                ></icon
              ></span>
            </h6>

            <b-tooltip
              v-if="
                headerData.groupDetail.flagGroup == true &&
                headerData.groupDetail.strStudents != ''
              "
              target="btnTooltipStudentGroup"
              id="tooltipStudentGroup"
              placement="right"
            >
              <ul>
                <li
                  v-for="(
                    student, index
                  ) in headerData.groupDetail.strStudents.split('|')"
                  :key="index"
                >
                  {{ student }}
                </li>
              </ul>
            </b-tooltip>

            <h6 class="sub-title">
              <span>{{ headerData ? headerData.group : "" }}</span>
            </h6>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label-cols-sm="3"
                  content-cols-sm="9"
                  :label="$t('my-class.report.status').concat(':')"
                >
                  <b-form-input
                    v-model="headerData.nameStateClass"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label-cols-sm="3"
                  content-cols-sm="9"
                  :label="$t('my-class.report.date').concat(':')"
                >
                  <b-input-group class="datepicker-group">
                    <b-form-input
                      v-model="headerData.date"
                      :disabled="true"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        button-only
                        right
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="en"
                        :disabled="true"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-form-group
                  v-if="
                    headerData.groupDetail != null &&
                    headerData.groupDetail.flagGroup
                  "
                  label-cols-sm="3"
                  content-cols-sm="9"
                  :label="$t('my-class.report.time').concat(':')"
                >
                  <b-form-input
                    v-model="headerData.hours"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <template
                  v-if="
                    headerData.groupDetail != null &&
                    !headerData.groupDetail.flagGroup
                  "
                >
                  <b-form-group
                    label-cols-sm="3"
                    content-cols-sm="9"
                    :label="$t('my-class.report.attendance').concat(':')"
                  >
                    <div class="d-flex mt-1">
                      <b-form-radio
                        class="present m-auto"
                        v-model="items[0].assistance"
                        :disabled="true"
                        :value="true"
                        >{{
                          $t("my-class.report.present").concat(":")
                        }}</b-form-radio
                      >
                      <b-form-radio
                        class="absent ml-5"
                        v-model="items[0].assistance"
                        :disabled="true"
                        :value="false"
                        >{{
                          $t("my-class.report.absent").concat(":")
                        }}</b-form-radio
                      >
                    </div>
                  </b-form-group>
                  <b-form-group>
                    <b-form-row>
                      <legend class="col-sm-3 bv-no-focus-ring col-form-label">
                        {{ $t("my-class.report.time").concat(":") }}
                      </legend>
                      <b-col
                        sm="9"
                        class="d-flex align-items-center"
                        style="gap: 1rem"
                      >
                        <b-form-input
                          v-model="headerData.hours"
                          :disabled="true"
                        ></b-form-input>
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                </template>
                <div v-else class="table-assistance">
                  <div class="container-assistance">
                    <b-table
                      sticky-header
                      :items="items"
                      :fields="fields"
                      responsive="sm"
                      class="w-100 mb-0"
                      :show-empty="true"
                      :empty-text="$t('reusables.empty-text')"
                    >
                      <template #cell(assistance)="data">
                        <b-form-group class="container-radio mb-0">
                          <b-form-radio
                            class="present m-auto"
                            v-model="data.item.assistance"
                            :disabled="true"
                            :value="true"
                          />
                        </b-form-group>
                      </template>
                      <template #cell(absent)="data">
                        <b-form-group class="container-radio mb-0">
                          <b-form-radio
                            class="absent"
                            v-model="data.item.assistance"
                            :disabled="true"
                            :value="false"
                          />
                        </b-form-group>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card mt-3" v-if="dataReport != null && headerData != null">
          <div class="card-body">
            <div :style="{ 'margin-top': '0px' }">
              <b-row>
                <b-col md="6">
                  <b-form-group
                    label-cols-sm="3"
                    content-cols-sm="9"
                    :label="$t('my-class.report.teacher').concat(':')"
                  >
                    <legend class="col-form-label">
                      {{ headerData.teacherName }}
                    </legend>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-cols-sm="3"
                    content-cols-sm="9"
                    :label="$t('my-class.report.cour').concat(':')"
                  >
                    <b-form-input
                      v-model="dataReport.nameSelectedCourses"
                      :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group>
                    <b-form-row>
                      <legend
                        class="col-form-label"
                        style="flex: 0 0 12%; max-width: 12%"
                      >
                        {{ $t("my-class.report.topics").concat(":") }}
                      </legend>
                      <b-col>
                        <b-list-group class="w-100" :class="'disabled'">
                          <b-list-group-item>
                            <b-form-input
                              v-model.trim="dataReport.eTopic.description"
                              :disabled="true"
                            ></b-form-input>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-cols-sm="3"
                    content-cols-sm="9"
                    :label="$t('my-class.report.materials').concat(':')"
                  >
                    <b-form-input
                      class="mb-2"
                      v-for="(item, index) in dataReport.arrayMaterial"
                      :key="`item-${index}`"
                      v-model.trim="item.name"
                      :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-cols-sm="3"
                    content-cols-sm="9"
                    :label="$t('my-class.report.pages').concat(':')"
                  >
                    <b-form-input
                      class="mb-2"
                      v-for="(item, index) in dataReport.arrayMaterial"
                      :key="`item-${index}`"
                      v-model.trim="item.description"
                      :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group>
                    <b-form-row>
                      <legend
                        class="col-form-label"
                        style="flex: 0 0 12%; max-width: 12%"
                      >
                        {{ $t("my-class.report.comments").concat(":") }}
                      </legend>
                      <b-col>
                        <b-form-textarea
                          v-model.trim="dataReport.commentary"
                          :disabled="true"
                          rows="4"
                          no-resize
                        >
                        </b-form-textarea>
                      </b-col>
                    </b-form-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { getNextClassDate, getNextClassTime,  horarioObtenerNameClaseEnEsConsolidado } from "@/assets/js/util.js";

export default {
  data() {
    return {
      showSpinnerSave: false,
      lang: localStorage.getItem("lang") || "es",
      message: "",
      headerData: null,
      dataReport: null,
      fields: [
        {
          key: "student",
          label: this.$t("reusables.student").concat(":"),
          thClass: "text-left",
          tdClass: "text-left",
        },
        {
          key: "assistance",
          label: this.$t("my-class.report.present"),
        },
        {
          key: "absent",
          label: this.$t("my-class.report.absent"),
        },
      ],
      items: [],
      options: [],
    };
  },

  computed: {
    disabledForm: function () {
      let count = 0;
      this.items.forEach((element) => {
        if (!element.assistance && element.assistance != null) {
          count++;
        }
      });

      if (this.items.length == count) {
        return true;
      }

      return false;
    },
    groupId: {
      get() {
        return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      },
    },
    User: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  created() {
    this.getDetailReport();
  },
  methods: {
    getDetailReport() {
      let data = {
        Id: this.$route.params.id,
        flagLenguage: this.lang == "es" ? true : false,
      };
      let format_day = "DD/MM/YYYY";
      let format_time = "h:mm a";

      baseInstanceAxios
        .get(`${this.apiURL}/resources/GroupsPlanClass/GetByIdStudent`, {
          params: data,
        })
        .then((response) => {
          if (response.data.entity.groupScheduleStudentDetail) {
            this.headerData = {
              date: getNextClassDate(
                response.data.entity.groupScheduleStudentDetail.startDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_day
              ),
              hours: getNextClassTime(
                response.data.entity.groupScheduleStudentDetail.startDate,
                response.data.entity.groupScheduleStudentDetail.endDate,
                this.$store.state.user.timeZoneName,
                this.$moment,
                format_time
              ),
              groupDetail: response.data.entity.group,
              teacherName: response.data.entity.teacherName,
              nameStateClass: horarioObtenerNameClaseEnEsConsolidado(response.data.entity.valueStateClass) ,
              duration: this.formatClassDuration(
                response.data.entity.groupScheduleStudentDetail
              ),
            };
          }

          let arrayStudents =
            response.data.entity.listGroupsPlanClassAttendances;
          if (arrayStudents) {
            this.items = arrayStudents.map((x) => ({
              student: x.person.strFullName,
              assistance: x.flagAttendance,
              /* present: x.flagAttendance,
              absent: x.flagAttendance == false, */
            }));
          }
          let entityReport = null;
          if (response.data.entity.getGroupsPlanClassSubject != null) {
            let element = response.data.entity.getGroupsPlanClassSubject;
            let arrayMaterial =
              element.listDtoGroupsPlanClassSubjectMaterials.map((x) => ({
                name: x.name,
                description: x.description,
                idx: x.id,
              }));

            let eTopic =
              element.getDtoGroupsPlanClassSubjectTopics == null
                ? null
                : {
                    description:
                      element.getDtoGroupsPlanClassSubjectTopics.description,
                    idx: element.getDtoGroupsPlanClassSubjectTopics.id,
                  };
            entityReport = {
              id: element.id,
              selectedCourses: element.groupRegisterSubjectId,
              nameSelectedCourses: element.subjectsName,
              commentary: element.comment,
              eTopic: eTopic,
              arrayMaterial: arrayMaterial,
              subjectsPosition: element.subjectsPosition,
            };
          } else {
            entityReport = {
              id: 0,
              selectedCourses: null,
              nameSelectedCourses: null,
              commentary: null,
              eTopic: {
                description: null,
              },
              arrayMaterial: [
                {
                  name: null,
                  description: null,
                  idx: 0,
                },
              ],
            };
          }

          this.dataReport = entityReport;
        });
    },
    formatClassDuration(item) {
      var duration = "";

      var milliseconds = this.$moment
        .duration(this.$moment(item.endDate).diff(this.$moment(item.startDate)))
        .asMilliseconds();
      var hours = Math.trunc(this.$moment.duration(milliseconds).asHours());
      var minutes = this.$moment.duration(milliseconds).minutes();

      if (hours < 1) {
        duration = this.$moment.utc(milliseconds).format("mm [min.]");
      } else if (hours == 1 && minutes == 0) {
        duration = this.$moment.utc(milliseconds).format("H [hr.]");
      } else if (hours == 1 && minutes > 0) {
        duration = this.$moment.utc(milliseconds).format("H [hr.] mm [min.]");
      } else if (hours > 0 && minutes == 0) {
        duration = this.$moment.utc(milliseconds).format("H [hrs.]");
      } else {
        duration = this.$moment.utc(milliseconds).format("H [hrs.] mm [min.]");
      }
      return duration;
    },
  },
};
</script>